module.exports = __webpack_public_path__ + "static/media/stars-1536.729a9860.webp";